<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('add_broker') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="name" class="required"> Name </label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="name"
                            placeholder="Packer name"
                        />
                        <br>
                        <label for="description">Description</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="description"
                            placeholder="Description"
                        />
                        <br>
                        <label for="fda">Fda</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="fda"
                            placeholder="fda"
                        />
                        <label for="fax">Fax</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="fax"
                            placeholder="fax"
                        />
                        <label for="email">Email</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="email"
                            placeholder="email"
                        />
                        <label for="phone">Phone</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="phone"
                            placeholder="phone"
                        />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "AddCountry",
    data() {
        return {
            name : "",
            description : "",
            fda : "",
            fax : "",
            email : "",
            phone : "",
        };
    },
    methods: {
        submit() {
            if (this.name === '') {
                this.$toastr.e('Name is required');
                return;
            }
            const data = {
                name : this.name,
                description : this.description,
                fda : this.fda,
                fax : this.fax,
                Email : this.email,
                phone : this.phone,
            }
            this.$emit("save", data);
        },
    },
};
</script>
  